require('../../modules/es.object.set-prototype-of');
var path = require('../../internals/path');

module.exports = path.Object.setPrototypeOf;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/object/set-prototype-of.js
// module id = 380
// module chunks = 0 1